<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">

  <!-- Page Title Section -->
  <div class="page-title-section">
    <h2>Assurance Mutuelle Santé Professionnelle</h2>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <p>
      Le contrat d'assurance <strong class="text-purple">Mutuelle Santé Professionnelle</strong> a pour objet de garantir le remboursement des dépenses de santé de tout ou partie des frais médicaux, chirurgicaux et/ou d'hospitalisation occasionnées par une maladie, un accident ou une maternité survenus pendant la période d'adhésion, ainsi que les frais de santé non pris en charge par votre Régime Obligatoire de Sécurité Sociale (RSI, CARCDSF, CARMF, CARPIMKO, CARPV, CAVAMAC, CAVAMAC, CAVEC, CAVP, CRN, CIPAV) au profit des personnes assurées défini sur votre contrat (souvent vous seul, ou avec votre famille), dans les conditions et limites des niveaux de garanties souscrites souscrites au contrat, et dans la limite des frais réels et de la base de remboursement de votre SS.
    </p>
    <p>
      Le contrat santé souscrit par un TNS est souvent moins cher que celui souscrit par un particulier. Et ce pour deux raisons majeures :
    </p>
    <ul>
      <li>Il est statistiquement prouvé qu'un TNS va beaucoup moins chez le médecin qu'un particulier. L'assureur baisse donc les tarifs, car ce contrat reste louable pour lui,</li>
      <li>D'un point de vue fiscal, et plus précisément grâce au régime fiscal dit <strong class="text-purple">MADELIN</strong>, le TNS peut déduire une très grande partie (près de <strong class="highlight-purple">90%</strong>) des cotisations de ses contrats complémentaires de protection sociale (santé, prévoyance, retraite) de ses revenus professionnels soumis à impôts.</li>
    </ul>
    <p>
      Le contrat d'assurance santé est souvent appelé complémentaire santé ou alors Mutuelle Santé. Nous parlons bien de la même chose. D'ailleurs, les contrats d'assurance santé sont proposés par 4 types d'acteurs : Les Mutuelles, les Assureurs, les Institutions de Prévoyance, les Courtiers Grossistes et enfin les Bancassureurs.
    </p>
    <p>
      Le <strong class="text-purple">TNS</strong> est le travailleur non salarié, c'est à dire une profession libérale, un artisan, commerçant, gérant majoritaire d'une sarl (ou gérant d'une entreprise individuelle de type EURL).
    </p>
    <p>
      Il existe également des Mutuelles Santé dédiées aux mandataires sociaux de type Président ou Directeur Général d'une SAS/SASU. Comme pour le TNS, ce contrat reviendra moins cher que le contrat souscrit de manière personnelle en tant que particulier. Mais le mandataire social de société n'a pas droit au régime fiscal Madelin dans la mesure où il est considéré comme assimilé salarié.
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, AXA SPVIE, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, ASAF & AFPS, ENTORIA, HENNER, APIVIA MACIF, AVENIR MUTUELLE , IDENTITE MUTUELLE, UCR, PRAECONIS…</strong>
    </p>
  </div>

  <!-- Devis Button -->
  <div class="devis-button-wrapper">
    <button class="btn-devis" (click)="navigateToComparison()">
      Devis en ligne
    </button>
  </div>

  <!-- Additional Content Sections -->
  <div class="additional-content">
    <div class="content-section">
      <h3 class="purple-text">Une protection indispensable pour protéger votre santé</h3>
      <p>Votre contrat assurance santé vous garantit donc pour :</p>
      <ul>
        <li>Les consultations et soins de médecins généralistes ou spécialistes,</li>
        <li>Les frais de radiologie, d'échographie,</li>
        <li>Les frais d'analyses médicales et d'auxiliaires médicaux,</li>
        <li>La pharmacie (médicaments remboursés par la Sécurité sociale),</li>
        <li>Les prothèses dentaires,</li>
        <li>Les prothèses non dentaires,</li>
        <li>Les médecines douces,</li>
        <li>Le bien-être : Cure thermale…,</li>
        <li>L'appareillage : appareil auditif, orthèse (semelle orthopédique, …).</li>
      </ul>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Le saviez-vous ?</h3>
      <p>
        Face au désengagement progressif de la Sécurité sociale en matière de frais de santé, le reste à charge (ce qui reste à payer de votre poche) pour les patients ne cesse de s'alourdir. D'autant que la consommation de soins et de biens médicaux tend à croître à mesure que l'on avance en âge… En effet, pour les seniors par exemple, des études indiquent que les dépenses de santé sont multipliées par <strong class="highlight-purple">3,5</strong> entre <strong class="highlight-purple">55 ans et 80 ans</strong>, le poste d'hospitalisation prend une place de plus en plus importante dans les soins. Pourquoi ? Le coût d'une hospitalisation peut varier entre <strong class="highlight-purple">66€ et 446€/j</strong>. Il ne faut donc pas se tromper de formules.
      </p>
      <p>
        Dans ce contexte, disposer d'une couverture santé adaptée répondant à ses attentes et à son budget tout en bénéficiant de bons niveaux de remboursement est indispensable.
      </p>
      <p>
        Avec l'âge, lorsque l'état de santé se détériore, certains besoins de remboursement deviennent requis et répétitifs pour l'assuré surtout si il n'est pas assuré en santé complémentaire puisque que ticket modérateur et dépassement d'honoraire (partie des honoraires dépassant le tarif de convention de la sécurité sociale, ex : <strong class="highlight-purple">23 €</strong> pour un généraliste) resteront à charge, en voici une liste non exhaustive :
      </p>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Hospitalisation :</h3>
      <p>
        Les frais liés à une hospitalisation : Une hospitalisation peut arriver et devenir rapidement réalisable et préoccupante pour votre entourage. Si vous avez une couverture de base à la sécurité sociale, vous devrez régler le « ticket modérateur », soit <strong class="highlight-purple">20 %</strong> du prix de journée (hébergement, médicaments, examens de laboratoire, soins, interventions chirurgicales, frais de salle d'opération, produits sanguins, actes de radiologie, prothèses). Des dépassements d'honoraires peuvent également être pratiqués par des médecins hospitaliers exerçant en profession libérale.
      </p>
      <p>
        Le tarif des prestations hospitalières correspond aux coûts des frais de santé et dépend donc du problème de santé donnant lieu à l'hospitalisation. Il est défini sous la forme d'un montant par jour d'hospitalisation :
      </p>
      <ul>
        <li>Pour les hôpitaux publics et privés sans but lucratif, ce montant est défini par chaque directeur d'établissement et donc variable d'un hôpital à l'autre,</li>
        <li>Pour les cliniques /hôpitaux privés, ce montant est défini nationalement et donc le même dans chaque établissement.</li>
      </ul>
      <p>
        Une attention particulière à porter aux attentes des assurés, est le remboursement de la chambre particulière et des actes de spécialité en secteur conventionné (cardiologie, rhumatologie…):
      </p>
      <ul>
        <li>Hospitalisation : Généralement, les frais de séjour et Chirurgie sont pris en charge sur la base des frais réels par les formules intermédiaires des complémentaires santé,</li>
        <li>Après une hospitalisation, des mutuelles financent à hauteur de <strong class="highlight-purple">30/60j</strong> les maisons de repos,</li>
        <li>Les chambres particulières ainsi que les extras sont également pris en charge sur une bonne base par les formules intermédiaires des complémentaires santé (<strong class="highlight-purple">80€/j</strong>).</li>
      </ul>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Optiques :</h3>
      <p>
        Avec le temps le vue baisse, l'achat de lunettes de qualités est très importantes. Les lunettes avec correction simple sont généralement remboursées à hauteur de <strong class="highlight-purple">5 euros</strong>, pour les verres complexes et très complexes en optique, le remboursement reste très en dessous des frais réels. Bien que la réforme <strong class="text-purple">100 % santé</strong> soit passée, il se peut que par coquetterie vous vouliez avoir une monture de marque. Certaines mutuelles peuvent prendre tout ou partie du prix des montures.
      </p>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Dentaires non remboursés :</h3>
      <p>
        Que vous soyez une personne âgée, ou non, et vous avez un besoin très particulier en dentaire, notamment sur les postes de Prothèses, d'implants, et de parodontologie une bonne assurance santé est nécessaire. Quand on sait qu'une prothèse compléte peut coûter jusqu'à <strong class="highlight-purple">1000 €</strong>, et que la sécu en rembourse que <strong class="highlight-purple">90€</strong>, le besoin de couverture s'en fait sentir.
      </p>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Médecines douces/naturelles et préventions :</h3>
      <p>
        Les médecines non traditionnelles ont le vent en poupe. Toutes les mutuelles ne les fument pas en charge. Par ailleurs, deux types de besoins peuvent répondre aux personnes voulant réduire leur rapport à médecine conventionnelle :
      </p>
      <p>
        La cure thermale (Attention : ne confondez pas thermalisme et thalassothérapie. La thalassothérapie propose des prestations exclusivement préventives et de bien-être qui ne sont pas prises en chargé par l'Assurance Maladie, alors que le thermalisme a délivré des soins contre des maladies chroniques. Ces soins peuvent être remboursés par l'Assurance Maladie.) ainsi que des besoins en Pédicure, podologue, ostéopathie, kinésithérapie, etc etc … .
      </p>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Audition :</h3>
      <p>
        Différentes causes peuvent expliquer l'apparition de la déficience auditive mais pour la majorité des individus, la raison principale en est l'usure des cellules sensorielles avec l'âge. Celle-ci commence de plus en plus tôt et est apparente vers <strong class="highlight-purple">55 ans</strong>. Soit, en France, l'âge moyen du premier équipement est de <strong class="highlight-purple">70 ans</strong>. Le besoin des seniors est donc dans l'équipement en petit appareillage auditif, dont le prix est de l'ordre de <strong class="highlight-purple">1500 euros/oreille</strong>.
      </p>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Frais accessoires :</h3>
      <ul>
        <li>ostéodensitométrie, diagnostic prostate, Petit appareillage non remboursé (bas de contention) : pouvant aller jusqu'à <strong class="highlight-purple">100 €</strong> chez certains assureurs.</li>
        <li>Traitement ménopause / andropause (traitements érectiles) / insuffisance veineuse (traitements veinotiques) : pouvant aller jusqu'à <strong class="highlight-purple">100 €</strong> chez certains assureurs.</li>
        <li>Forfait sexualité et vie de couple : consultation d'un sexologue, médicaments des troubles érectiles comme le viagra et lubrifiants.</li>
      </ul>
    </div>

    <div class="content-section">
      <h3 class="purple-text">Pharmacie :</h3>
      <p>
        Si la pharmacie reste bien remboursée, un certain nombre de produits ne le sont pas. Certaines mutuelles proposent un budget annuel dédié au remboursement des médicaments non remboursés par l'assurance maladie.
      </p>
    </div>

    <div class="content-section">
      <h3 class="purple-text">L'absence d'avance de frais :</h3>
      <p>
        Sur simple présentation de votre carte de Tiers Payant Étendu, vous êtes offert d'avance de frais (dans la limite des garanties de votre contrat) chez près de <strong class="highlight-purple">160 000</strong> professionnels de la santé dont plus de <strong class="highlight-purple">10 000</strong> opticiens indépendants ou franchisés, des différents réseaux de soins (Réseau Carte Blanche etc ).
      </p>
    </div>

    <div class="content-section">
      <p>
        Bien évidement les possibilités en termes de couvertures sont énormes. Il existe des milliers de combinaisons possibles. Néanmoins, d'un assureur à un autre, les services (la qualité de gestion) ne sont pas les mêmes.
      </p>
      <p>
        Dans le cas d'une couverture en assurance santé uniquement en France, votre pays de résidence, ou pour tous les déplacements à l'étranger de moins de 3 mois, il vous sera nécessaire de souscrire plutôt une <strong class="text-purple">Assurance Mutuelle Santé Individuelle</strong> dont vous trouverez plus d'informations ici .
      </p>
      <p>
        Il est très fréquent, en tant que travailleur non salarié (TNS), auto-entrepreneur, mandataire social de SAS, pour bénéficier d'une protection sociale complète comme les salariés, de souscrire une <strong class="text-purple">Assurance Prévoyance Professionnelle</strong> dont vous pouvez trouver plus de détails ici , et d'un plan épargne retraite (PERInd ou PER Individuel) appelé <strong class="text-purple">Assurance Retraite Complémentaire Professionnelle</strong> dont vous pouvez trouver plus de détails ici .
      </p>
    </div>
  </div>

</app-page-layout>
